import React, { Component } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import Formatter from '../../utils/Formatter';
import AnalysisTools from '../../utils/AnalysisTools';
import Breakdown from './Breakdown';
import { Button } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NestedLoanBreakdown from './NestedLoanBreakdown';
import SingleLoanGroup from './EachLoan';

class LoansGroup extends Component {
  state = {
    expanded: false,
  };


  toggleExpansion = () => {
    this.setState({ expanded: !this.state.expanded });
  };



  getTitle = () => {
    if (this.props.consolidate) {
      return 'LOANS THAT SHOULD BE CONSOLIDATED';
    }
    return 'LOANS THAT SHOULD NOT BE CONSOLIDATED';
  };

  getRecommendedPlan = () => {
    const recommendedPlan = this.props.loansGroup.plans.find(
      (plan) => plan.recommended
    );
    return recommendedPlan;
  };

  getRecommendedPlanCode = () => {
    const recommendedPlan = this.getRecommendedPlan()
    return  recommendedPlan && recommendedPlan.plan;
  };

  getLoanGroups = () => {
    for (let key in this.props.loanGroup) return this.props.loanGroup[key];
  };

  getForgivenessAmount = (repayment) => {
    const totalForgiveness = repayment.forgiveness.reduce((acc, curr) => (acc += curr.value), 0);
    const totalOutstandingBalance = repayment.outstandingBalance.reduce((acc, curr) => (acc += curr.value), 0);
    return Number((totalForgiveness || totalOutstandingBalance).toFixed(2));
  }

  getPayoffAmount = (repayment) => {
    const totalForgiveness = this.getForgivenessAmount(repayment);
    const totalOutstandingBalance = repayment.outstandingBalance.reduce((acc, curr) => (acc += curr.value), 0);
    const payoff = repayment.payoff.reduce((acc, curr) => (acc += curr.value), 0);
    if (totalOutstandingBalance <= totalForgiveness) {
      return `$${Formatter.money(payoff)}`
    }
    return `$${Formatter.money(payoff)} ($${Formatter.money(totalOutstandingBalance - totalForgiveness)})`;
  }

  getEmployerContributionValue = (isRecommended, mmp) => {
    if (isRecommended && this.props.account.employment.contribution?.value) {
      const mmpValue = (mmp.reduce((acc, curr) => (acc += curr.value), 0))
      const type = this.props.account.employment.contribution.type;
      const value = this.props.account.employment.contribution.value;
      let employer_contribution;
      if (type === "percentage") {
        employer_contribution = (value / 100) * mmpValue
        return `($${Formatter.money(employer_contribution)})`
      } else {
        return `($${Formatter.money(value / (this.props.loangroups || 1))})`
      }
    }
    return ""
  }

  getForgivenessType = (type, isRecommended) => {
    const forgivenessTypeText = ["PSLF", "PERKINS", "HIGH TLF", "TLF", "IDR", "NONE"]
    if (isRecommended && [2, 3].includes(type)) {
      return ` (${forgivenessTypeText[type]})`;
    }
    return;
  }

  render() {
    const { loansGroup, account } = this.props;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className='text-center' colSpan={9}>
              {this.getTitle()}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>Loan Type</TableCell>
            <TableCell>Balance</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Current Repayment Plan</TableCell>
            <TableCell>Rate</TableCell>
            <TableCell>MMP</TableCell>
            <TableCell>Recommended Plan</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loansGroup.loans.map((loan) => (
            <>
              <SingleLoanGroup loan={loan} account={account} recommendedPlan={this.getRecommendedPlanCode()} />

            </>
          ))}
        </TableBody>
        <TableHead>
          <TableRow>
            <TableCell className='text-center' colSpan={9}>
              Analysis Preview
            </TableCell>
          </TableRow>
        </TableHead>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>Repayment Plan</TableCell>
            <TableCell>MMP</TableCell>
            <TableCell>Monthly Interest Subsidy</TableCell>
            <TableCell>Forgiveness</TableCell>
            <TableCell>Payments</TableCell>
            <TableCell>Payoff</TableCell>
            <TableCell>Last Payment</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loansGroup.plans.map((repayment, index) => (
            <>
              <TableRow
                key={index}
                className={repayment.recommended ? 'current-repayment' : ''}
              >
                <TableCell colSpan={2}>
                  {Formatter.repaymentPlanText(repayment.plan)}
                </TableCell>
                <TableCell>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>
                      {`$${Formatter.money(
                        repayment.mmp.reduce((acc, curr) => (acc += curr.value), 0)
                      )}`}
                    </span>
                    <span>
                      {this.getEmployerContributionValue(repayment.recommended, repayment.mmp)}
                    </span>
                  </div>
                </TableCell>
                <TableCell>
                  {`$${Formatter.money(
                    repayment.subsidy.reduce(
                      (acc, curr) => (acc += curr.value),
                      0
                    )
                  )}`}
                </TableCell>
                <TableCell>
                  { `$${Formatter.money(this.getForgivenessAmount(repayment))}`}
                  {
                     this.getForgivenessType((loansGroup.loans[0] || {}).forgivenessType, repayment.recommended)
                  }
                </TableCell>
                <TableCell>
                  {Math.max(...repayment.periods.map((i) => i.value))}
                </TableCell>
                <TableCell>
                  { this.getPayoffAmount(repayment)}
                </TableCell>
                <TableCell>
                  {Math.max(...repayment.lastPaymentYear.map((i) => i.value))}
                </TableCell>
                <TableCell>
                  {repayment.recommended && (
                    <Button onClick={() => this.props.toggleYearlyBreakdown(loansGroup.plans)}>
                      Yearly Breakdown
                    </Button>
                  )}
                </TableCell>
                {repayment.recommended && (
                  <NavigateNextIcon
                    onClick={this.toggleExpansion}
                    className={`navigate-next ${this.state.expanded ? 'opened' : ''
                      }`}
                  />
                )}
              </TableRow>

              {this.state.expanded && repayment.recommended && (
                <Breakdown
                  consolidationStrategy={1}
                  loans={loansGroup.loans}
                  plan={this.getRecommendedPlan(loansGroup.plans)}
                  analysis={account.analysis}
                />
              )}
            </>
          ))}
        </TableBody>
      </Table>
    );
  }
}

export default LoansGroup;
